import config from './config.js';
import { ethers } from '/node_modules/ethers/dist/ethers.esm.min.js';
import CONTRACT_ABI from '../public/contractAbi.json';
import whitelist from '../public/whitelist.json';
import { MerkleTree } from 'merkletreejs';
import { EthereumProvider } from '@walletconnect/ethereum-provider';

const keccak256 = ethers.utils.keccak256;

window.onload = () => {
  const connectWalletButton = document.getElementById('connect-wallet');
  const mintNFTButton = document.getElementById('mint-nft');
  const connectedWalletElement = document.getElementById('connected-wallet');
  const tokensMintedElement = document.getElementById('tokens-minted');
  const tokensMintedCountElement = document.getElementById('tokens-minted-count');
  const mintedTokensCounter = document.getElementById('minted-tokens-counter');
  const walletInput = document.getElementById('wallet-input');

  mintedTokensCounter.classList.add('hidden');
  mintNFTButton.style.display = 'none';
  tokensMintedElement.style.display = 'none';

  let provider;
  let signer;
  let account;
  let connectedWalletMerkleProof = null;
  let isWhitelistPhaseActive = true; // Set this flag based on the active phase

  const CONTRACT_ADDRESS = config.CONTRACT_ADDRESS;
  const GOERLI_NETWORK_ID = 5;
  const MAINNET_NETWORK_ID = 1;

  //Generate Merkle Proof for connected wallet function (ie. upon connection IF is whiteList)
  async function generateMerkleProofForConnectedWallet(walletAddress) {
    if (!whitelist.includes(walletAddress)) {
      return null;
    }
  
    const leaves = whitelist.map((address) => keccak256(Buffer.from(address.slice(2), 'hex')));
    const merkleTree = new MerkleTree(leaves, keccak256, { sortPairs: true });
    const leaf = keccak256(Buffer.from(walletAddress.slice(2), 'hex'));
    const merkleProof = merkleTree.getProof(leaf).map((element) => element.data);
    return merkleProof.map((proof) => '0x' + proof.toString('hex'));
  }  
  

  const walletAddressInput = document.getElementById('wallet-input');
  const generateProofButton = document.getElementById('generate-proof'); 
  generateProofButton.addEventListener('click', generateMerkleProofWithoutConnecting);

//End of generateMerkleProofForConnectedWallet function

//Start of Merkle proof without connecting function
  async function generateMerkleProofWithoutConnecting() {
    // Get the wallet address from the input field
    const walletAddress = walletAddressInput.value;
    if (!walletAddress) {
      alert('Please enter a wallet address.');
      return;
    }
  
    // Check if the wallet address is valid
    if (!ethers.utils.isAddress(walletAddress)) {
      alert('Invalid wallet address.');
      return;
    }
  
    // Check if the wallet address is in the whitelist
    if (!whitelist.includes(walletAddress)) {
      alert('Wallet is not in the Whitelist.');
      return;
    }
  
    // Create the Merkle tree leaves
    const leaves = whitelist.map((address) => keccak256(Buffer.from(address.slice(2), 'hex')));
    console.log('Leaves:', leaves);
  
    // Create the Merkle tree with the option { sortPairs: true }
    const merkleTree = new MerkleTree(leaves, keccak256, { sortPairs: true });
  
    // Generate the Merkle proof for the given wallet address
    const leaf = keccak256(Buffer.from(walletAddress.slice(2), 'hex'));
    console.log('Leaf:', leaf);
    const merkleProof = merkleTree.getProof(leaf).map((element) => element.data);
    console.log('Merkle proof:', merkleProof);
  
    // Format the Merkle proof
    const merkleProofString = merkleProof.map((proof) => '0x' + proof.toString('hex')).join(',');
    console.log('Merkle proof string:', merkleProofString);
  
    // Copy the Merkle proof to the clipboard
    navigator.clipboard.writeText(merkleProofString).then(() => {
      console.log('Clipboard write successful');
      alert(`Merkle proof for the wallet address ${walletAddress} has been copied to the clipboard: ${merkleProofString}`);
    }, (error) => {
      console.error('Clipboard write failed', error);
      alert('Failed to copy Merkle proof to the clipboard. Please try again.');
    });
  }    
// End of Generate merkle proof without connecting function 

//checkWhitelist mint status function start 
  async function checkWhitelistMintStatus() {
    try {
      const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);
      const isWhitelistMintEnabled = await contract.whitelistMintEnabled();
      console.log('Is whitelist mint enabled:', isWhitelistMintEnabled);
  
      if (isWhitelistMintEnabled) {
        mintNFTButton.textContent = 'Whitelist Mint';
  
        console.log('Whitelist:', whitelist);
  
        if (whitelist.map(address => address.toLowerCase()).includes(account.toLowerCase())) {
          mintNFTButton.disabled = false;
        } else {
          mintNFTButton.disabled = true;
          alert('Wallet is not in the Whitelist');
        }
      } else {
        mintNFTButton.textContent = 'Public Mint';
        mintNFTButton.disabled = false;
      }
    } catch (error) {
      console.error('Failed to check whitelist mint status:', error);
    }
  }     
//End of checkWhitelist mint function 

//updateMintedTokensCounter fucntion Start 
  async function updateMintedTokensCounter() {
    try {
      // Use the imported CONTRACT_ABI directly
      const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);
      const totalMinted = await contract.totalSupply();
      mintedTokensCounter.textContent = `Minted tokens: ${totalMinted}`;
      mintedTokensCounter.classList.remove('hidden');
    } catch (error) {
      console.error('Failed to update minted tokens counter:', error);
    }
}
//updateMintedTokensCounter function End

//connectWallet function Start for Metamask and Coinbase
async function connectWallet(walletProvider) {
  const { ethereum, web3 } = window;

  if (!ethereum && !web3) {
    console.error('Ethereum object not found. Please install a Web3 wallet.');
    return;
  }

  switch (walletProvider) {
    case 'metamask':
      if (!ethereum || !ethereum.isMetaMask) {
        console.error('MetaMask is not installed');
        return;
      }
      provider = new ethers.providers.Web3Provider(ethereum);
      break;

    case 'coinbase':
      if (web3 && web3.currentProvider?.isToshi) {
        provider = new ethers.providers.Web3Provider(web3.currentProvider);
      } else if (ethereum && (ethereum.isCoinbaseWallet || ethereum.isToshi)) {
        provider = new ethers.providers.Web3Provider(ethereum);
      } else {
        console.error('Coinbase Wallet is not installed');
        return;
      }
      break;
  }

  signer = provider.getSigner();

  const network = await provider.getNetwork();

  if (network.chainId === GOERLI_NETWORK_ID) {
    console.warn('Warning: Connected to Goerli Test Network');
    alert('Warning: Connected to Goerli Test Network');
  }

  try {
    await ethereum.request({ method: 'eth_requestAccounts' });
    account = await signer.getAddress();
    console.log(`Connected wallet: ${account}`);

    const contractCode = await provider.getCode(CONTRACT_ADDRESS);
    if (contractCode === '0x') {
      console.error('Error: contract not found, connect to the correct chain, please check wallet');
      alert('Error: contract not found, connect to the correct chain, please check wallet');
      return;
    }

    // Generate the Merkle proof for the connected wallet
    connectedWalletMerkleProof = await generateMerkleProofForConnectedWallet(account);

    connectedWalletElement.textContent = `Connected: ${account}`;
    connectedWalletElement.classList.remove('hidden');
    mintNFTButton.style.display = 'block';
    connectWalletButton.style.display = 'none';

    await updateMintedTokensCounter();
    document.getElementById('mint-amount').classList.remove('hidden'); // Show the mint-amount input field
    checkWhitelistMintStatus();
    mintNFTButton.disabled = false;

    // Create the contract instance
    const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);

    // Set the max mint amount per transaction for the mint amount input field
    const maxMintAmountPerTx = await contract.maxMintAmountPerTx();
    document.getElementById('mint-amount').setAttribute('max', maxMintAmountPerTx);

  } catch (error) {
    console.error('User denied account access:', error);
    alert('User denied account access: ' + error.message);
  }
}

connectWalletButton.addEventListener('click', () => {
  const walletModal = document.getElementById('wallet-modal');
  walletModal.classList.remove('hidden');

  const metamaskButton = document.getElementById('metamask');
  const coinbaseButton = document.getElementById('coinbase');

  metamaskButton.addEventListener('click', async () => {
    walletModal.classList.add('hidden');
    await connectWallet('metamask');
  });

  coinbaseButton.addEventListener('click', async () => {
    walletModal.classList.add('hidden');
    await connectWallet('coinbase');
  });
  
});
//connect wallet function End 

//Gnereic Wallet function Start ie. any wallet besides coinbase or metamask
 
async function connectGenericWallet() {
  const { ethereum } = window;

  if (!ethereum) {
    console.error('Ethereum object not found. Please install a Web3 wallet.');
    return;
  }

  if (ethereum.isMetaMask) {
    console.log('MetaMask is installed. Use the MetaMask button to connect.');
    return;
  }

  if (ethereum.isCoinbaseWallet) {
    console.log('Coinbase Wallet is installed. Use the Coinbase Wallet button to connect.');
    return;
  }

  try {
    await ethereum.request({ method: 'eth_requestAccounts' });
    provider = new ethers.providers.Web3Provider(ethereum);
    signer = provider.getSigner();
    account = await signer.getAddress();
    console.log(`Connected wallet: ${account}`);

    const network = await provider.getNetwork();
    const chainId = parseInt(network.chainId, 16);

    if (chainId === GOERLI_NETWORK_ID) {
      console.warn('Warning: Connected to Goerli Test Network');
      alert('Warning: Connected to Goerli Test Network');
    }

    const contractCode = await provider.getCode(CONTRACT_ADDRESS);
    if (contractCode === '0x') {
      console.error('Error: contract not found, connect to the correct chain, please check wallet');
      alert('Error: contract not found, connect to the correct chain, please check wallet');
      return;
    }

    // Generate the Merkle proof for the connected wallet
    connectedWalletMerkleProof = await generateMerkleProofForConnectedWallet(account);

    connectedWalletElement.textContent = `Connected: ${account}`;
    connectedWalletElement.classList.remove('hidden');
    mintNFTButton.style.display = 'block';
    connectWalletButton.style.display = 'none';

    document.getElementById('metamask').style.display = 'none';
    document.getElementById('coinbase').style.display = 'none';
    document.getElementById('other').style.display = 'none';

    await updateMintedTokensCounter();
    document.getElementById('mint-amount').classList.remove('hidden'); // Show the mint-amount input field
    checkWhitelistMintStatus();
    mintNFTButton.disabled = false;

    // Create the contract instance
    const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);

    // Set the max mint amount per transaction for the mint amount input field
    const maxMintAmountPerTx = await contract.maxMintAmountPerTx();
    document.getElementById('mint-amount').setAttribute('max', maxMintAmountPerTx);

  } catch (error) {
    console.error('User denied account access:', error);
    alert('User denied account access: ' + error.message);
  }
}


document.getElementById('other').addEventListener('click', async () => {
  await connectGenericWallet();
});


//----Generic Wallet function 


  mintNFTButton.addEventListener('click', async () => {


    if (!provider || !signer || !account) {
      console.log('Please connect your wallet first.');
      alert('Please Connect Wallet First');
      return;
    }
  
    // Get the mint amount from the input field
    const mintAmount = parseInt(document.getElementById('mint-amount').value, 10);
  
    try {
      const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
  
      // Get the cost per token from the contract
      const costPerToken = await contract.cost();
      
      // Calculate the total cost
      const totalCost = costPerToken.mul(mintAmount);
  
      // Get the max mint amount per transaction from the contract
      const maxMintAmountPerTx = await contract.maxMintAmountPerTx();
      document.getElementById('mint-amount').setAttribute('max', maxMintAmountPerTx);
  
      // Check if whitelist minting is enabled
      const isWhitelistMintEnabled = await contract.whitelistMintEnabled();
  
      let mintingTx;
      if (isWhitelistMintEnabled && connectedWalletMerkleProof) {
        // Call the whitelistMint function with the mint amount, Merkle proof array, and total cost
        mintingTx = await contract.whitelistMint(mintAmount, connectedWalletMerkleProof, {
          value: totalCost
        });
      } else {
        // Call the mint function with the mint amount and total cost
        mintingTx = await contract.mint(mintAmount, {
          value: totalCost
        });
      }
      console.log('Minting transaction sent:', mintingTx.hash);
      alert('Minting transaction sent: ' + mintingTx.hash);
  
      const receipt = await mintingTx.wait();
      console.log('Minting transaction confirmed:', receipt.transactionHash);
      alert('Minting transaction confirmed: ' + receipt.transactionHash);
  
      await updateMintedTokensCounter();
    } catch (error) {
      console.error('Minting failed:', error);
    }
  }); 

  //walletConnect function start
  let ethersProvider, contract;

  async function init() {
    try {
        // Initializing the provider
        provider = await EthereumProvider.init({
            projectId: '90d10cd91e70f8493d338019130bce1b',
            chains: [1],
            optionalChains: [5],
            showQrModal: true,
        });

        console.log('Provider is initialized', provider);

        if (provider) {
            console.log('Provider is initialized', provider);
        } else {
            console.log('Provider is undefined after initialization');
        }

        provider.on("connect", async () => {
            console.log('Wallet connected!');

            ethersProvider = new ethers.providers.Web3Provider(provider);
            signer = ethersProvider.getSigner();
            account = await signer.getAddress();
            console.log(`Connected wallet: ${account}`);

            connectedWalletMerkleProof = await generateMerkleProofForConnectedWallet(account);

            const connectedWalletElement = document.getElementById('connected-wallet');
            connectedWalletElement.textContent = `Connected: ${account}`;
            connectedWalletElement.classList.remove('hidden');

            document.getElementById('mint-nft').style.display = 'block';
            document.getElementById('connect-wallet').style.display = 'none';
            document.getElementById('metamask').style.display = 'none';
            document.getElementById('coinbase').style.display = 'none';
            document.getElementById('other').style.display = 'none';
            document.getElementById('connect-wallets').style.display = 'none';
            document.getElementById('wallet-modal').style.display = 'none';

            await updateMintedTokensCounter();
            document.getElementById('mint-amount').classList.remove('hidden');
            await checkWhitelistMintStatus();
            mintNFTButton.disabled = false;

            contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
            console.log('CONTRACT_ADDRESS:', CONTRACT_ADDRESS);

            const network = await ethersProvider.getNetwork();
            console.log('Connected to network:', network);

            const contractCode = await ethersProvider.getCode(CONTRACT_ADDRESS);

            if (contractCode === '0x') {
                console.error('Error: contract not found, connect to the correct chain, please check wallet');
                alert('Error: contract not found, connect to the correct chain, please check wallet');
                return;
            }

            try {
                const maxMintAmountPerTx = await contract.maxMintAmountPerTx();
                document.getElementById('mint-amount').setAttribute('max', maxMintAmountPerTx);
            } catch (error) {
                console.warn("maxMintAmountPerTx method not available on the contract");
            }
        });

        provider.on("disconnect", () => {
            console.log('Wallet disconnected!');
        });

        document.getElementById('connect-wallets').addEventListener('click', async () => {
            await provider.enable();
        });

       document.getElementById('mint-nft').addEventListener('click', async () => {

            if (!provider || !signer || !account) {
                console.log('Please connect your wallet first.');
                alert('Please Connect Wallet First');
                return;
            }

            const mintAmount = parseInt(document.getElementById('mint-amount').value, 10);

            try {
                const costPerToken = await contract.cost();
                const totalCost = costPerToken.mul(mintAmount);

                const isWhitelistMintEnabled = await contract.whitelistMintEnabled();

                let mintingTx;
                if (isWhitelistMintEnabled && connectedWalletMerkleProof) {
                    mintingTx = await contract.whitelistMint(mintAmount, connectedWalletMerkleProof, {
                        value: totalCost
                    });
                } else {
                    mintingTx = await contract.mint(mintAmount, {
                        value: totalCost
                    });
                }

                console.log('Minting transaction sent:', mintingTx.hash);
                alert('Minting transaction sent: ' + mintingTx.hash);

                const receipt = await mintingTx.wait();
                console.log('Minting transaction confirmed:', receipt.transactionHash);
                alert('Minting transaction confirmed: ' + receipt.transactionHash);

                await updateMintedTokensCounter();
            } catch (error) {
                console.error('Minting failed:', error);
            }
        });

    } catch (error) {
        console.error('Failed to initialize WalletConnect', error);
    }
}

async function checkWhitelistMintStatus() {
  try {
      console.log('Checking whitelist mint status...');
      const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);
      
      const isWhitelistMintEnabled = await contract.whitelistMintEnabled();
      console.log('Is whitelist mint enabled:', isWhitelistMintEnabled);
      
      // Add more logging to debug
      console.log('Whitelist:', whitelist);
      console.log('Account:', account);

      if (isWhitelistMintEnabled) {
          mintNFTButton.textContent = 'Whitelist Mint';
          
          if (whitelist.map(address => address.toLowerCase()).includes(account.toLowerCase())) {
              console.log('Account is in the whitelist');
              mintNFTButton.disabled = false;
          } else {
              console.log('Account is not in the whitelist');
              mintNFTButton.disabled = true;
              alert('Wallet is not in the Whitelist');
          }
      } else {
          console.log('Whitelist minting is disabled');
          mintNFTButton.textContent = 'Public Mint';
          mintNFTButton.disabled = false;
      }
  } catch (error) {
      console.error('Failed to check whitelist mint status:', error);
  }
}


// Calling the init function to initialize WalletConnect
//fuck it this thing works lol
init();


};
